import * as csLogHelper from "./helpers/CsLogHelper";
import {LogMessageTypeEnum} from "./helpers/CsLogHelper";
import {CsIndexedDbJsHelper} from "./CsIndexedDbJsHelper";
import {CsDeviceHelper} from "./CsDeviceHelper";
import {CsJsHelper, BrowserWindowInfo} from "./CsJsHelper";
import Bowser from "bowser";
import {CsContextKeyHelper} from "./CsContextKeyHelper";

export const CsContextKeyName: string = "CsContextKey";
export const CsDeviceIdKeyName: string = "CsDeviceId";
export const CsDeviceSignatureKeyName: string = "CsDeviceSignature";
// export const CsUserSignInRequestIdKeyName: string = "CsUserSignInRequestId";
export const CsUserSignInResponseIdKeyName: string = "CsUserSignInResponseId";
export const CsWksCsUserContextIdKeyName: string = "CsWksCsUserContextId";
export const CsRegionCodeKeyName: string = "CsRegionCode";
export const BrowserWindowInfoKeyName: string = "BrowserWindowInfo";
export const BowserParserParsedResultKeyName: string = "BowserParserParsedResult";

declare global {
  interface Window {
    __CsJsHelper: CsJsHelper | null | undefined;
    __CsIndexedDbJsHelper: CsIndexedDbJsHelper | null | undefined;
    __CsContextKeyHelper: CsContextKeyHelper | null | undefined;
    __CsDeviceHelper: CsDeviceHelper | null | undefined;

    __CsContextKey?: string | null | undefined;
    __CsDeviceId?: string | null | undefined;
    __CsDeviceSignature?: string | null | undefined;
    // __CsUserSignInRequestId?: string | null | undefined;
    __CsUserSignInResponseId?: string | null | undefined;
    __CsWksCsUserContextId?: string | null | undefined;
    __CsRegionCode?: string | null | undefined;

    __BrowserWindowInfo?: BrowserWindowInfo | null | undefined;
    __BowserParserParsedResult?: Bowser.Parser.ParsedResult | null | undefined;

    // Resolves once the startup hydration of the __Cs* globals from IndexedDB has completed. C# reads of
    // these globals must await this first, otherwise on a fresh load (e.g. browser back button) the C#
    // read runs before hydration finishes and sees the null initialisers (-> "Device invalid!" crash).
    __CsGlobalsReadyPromise?: Promise<void> | null | undefined;

    // The keys whose startup hydration THREW. Their global still holds the null initialiser, which is NOT the
    // stored value - a C# read of one of these must be treated as "not ready", never as "nothing stored".
    __CsGlobalsFailedKeys?: string[] | null | undefined;

    // Re-reads ONE key from IndexedDB into its window global. The C# read calls it for a key listed in
    // __CsGlobalsFailedKeys, so a transient IndexedDB failure at startup heals on the next read.
    __CsHydrateGlobalKey?: ((key: string) => Promise<void>) | null | undefined;

    // CsIndexedDbJsHelper writes a key to IndexedDB and then mirrors it into the matching __<key> window
    // global by calling window.updateGlobalVariables. It cannot import this module directly (NpmJs.ts
    // imports CsIndexedDbJsHelper, so that would be a circular import) - it looks the function up on
    // window instead, which means the assignment below is what makes the write-through work at all.
    updateGlobalVariables?: ((key: string, value: any) => void) | null | undefined;
  }
}

export declare namespace globalThis {
  let __CsJsHelper: CsJsHelper | null | undefined;
  let __CsIndexedDbJsHelper: CsIndexedDbJsHelper | null | undefined;
  let __CsContextKeyHelper: CsContextKeyHelper | null | undefined;
  let __CsDeviceHelper: CsDeviceHelper;
  let __CsContextKey: string | null | undefined;
  let __CsDeviceId: string | null | undefined;
  let __CsDeviceSignature: string | null | undefined;
  // let __CsUserSignInRequestId: string | null | undefined;
  let __CsUserSignInResponseId: string | null | undefined;
  let __CsWksCsUserContextId: string | null | undefined;
  let __CsRegionCode: string | null | undefined;
  let __BrowserWindowInfo: BrowserWindowInfo | null | undefined;
  let __BowserParserParsedResult: Bowser.Parser.ParsedResult | null | undefined;
  let __CsGlobalsReadyPromise: Promise<void> | null | undefined;
}

// TODO: is these initialisations needed with the below on load event???
globalThis.__CsJsHelper = new CsJsHelper();
window.__CsJsHelper = globalThis.__CsJsHelper;

globalThis.__CsIndexedDbJsHelper = new CsIndexedDbJsHelper();
window.__CsIndexedDbJsHelper = globalThis.__CsIndexedDbJsHelper;

globalThis.__CsContextKeyHelper = new CsContextKeyHelper();
window.__CsContextKeyHelper = globalThis.__CsContextKeyHelper;

globalThis.__CsDeviceHelper = new CsDeviceHelper();
window.__CsDeviceHelper = globalThis.__CsDeviceHelper;

globalThis.__CsContextKey = null;
window.__CsContextKey = globalThis.__CsContextKey;

globalThis.__CsDeviceId = null;
window.__CsDeviceId = globalThis.__CsDeviceId;

globalThis.__CsDeviceSignature = null;
window.__CsDeviceSignature = globalThis.__CsDeviceSignature;

// globalThis.__CsUserSignInRequestId = null;
// window.__CsUserSignInRequestId = globalThis.__CsUserSignInRequestId;

globalThis.__CsUserSignInResponseId = null;
window.__CsUserSignInResponseId = globalThis.__CsUserSignInResponseId;

globalThis.__CsWksCsUserContextId = null;
window.__CsWksCsUserContextId = globalThis.__CsWksCsUserContextId;

globalThis.__CsRegionCode = null;
window.__CsRegionCode = globalThis.__CsRegionCode;

globalThis.__BrowserWindowInfo = null;
window.__BrowserWindowInfo = globalThis.__BrowserWindowInfo;

globalThis.__BowserParserParsedResult = null;
window.__BowserParserParsedResult = globalThis.__BowserParserParsedResult;

export function updateGlobalVariables(
  key: string,
  value: any
) {
  console.log("ENTERED: updateGlobalVariables");

  switch (key) {
    case CsContextKeyName:
      if (value) {
        globalThis.__CsContextKey = value;
      }
      else {
        globalThis.__CsContextKey = null;
      }
      window.__CsContextKey = globalThis.__CsContextKey;
      break;
    case CsDeviceIdKeyName:
      if (value) {
        globalThis.__CsDeviceId = value;
      }
      else {
        globalThis.__CsDeviceId = null;
      }
      window.__CsDeviceId = globalThis.__CsDeviceId;
      break;
    case CsDeviceSignatureKeyName:
      if (value) {
        globalThis.__CsDeviceSignature = value;
      }
      else {
        globalThis.__CsDeviceSignature = null;
      }
      window.__CsDeviceSignature = globalThis.__CsDeviceSignature;
      break;
    // case CsUserSignInRequestIdKeyName:
    //   if (value) {
    //     globalThis.__CsUserSignInRequestId = value;
    //   }
    //   else {
    //     globalThis.__CsUserSignInRequestId = null;
    //   }
    //   window.__CsUserSignInRequestId = globalThis.__CsUserSignInRequestId;
    //   break;
    case CsUserSignInResponseIdKeyName:
      if (value) {
        globalThis.__CsUserSignInResponseId = value;
      }
      else {
        globalThis.__CsUserSignInResponseId = null;
      }
      window.__CsUserSignInResponseId = globalThis.__CsUserSignInResponseId;
      break;
    case CsWksCsUserContextIdKeyName:
      if (value) {
        globalThis.__CsWksCsUserContextId = value;
      }
      else {
        globalThis.__CsWksCsUserContextId = null;
      }
      window.__CsWksCsUserContextId = globalThis.__CsWksCsUserContextId;
      break;
    case CsRegionCodeKeyName:
      if (value) {
        globalThis.__CsRegionCode = value;
      }
      else {
        globalThis.__CsRegionCode = null;
      }
      window.__CsRegionCode = globalThis.__CsRegionCode;
      break;
    case BrowserWindowInfoKeyName:
      if (value) {
        globalThis.__BrowserWindowInfo = value;
      }
      else {
        globalThis.__BrowserWindowInfo = null;
      }
      window.__BrowserWindowInfo = globalThis.__BrowserWindowInfo;
      break;
    case BowserParserParsedResultKeyName:
      if (value) {
        globalThis.__BowserParserParsedResult = value;
      }
      else {
        globalThis.__BowserParserParsedResult = null;
      }
      window.__BowserParserParsedResult = globalThis.__BowserParserParsedResult;
      break;
  }
}

// THIS ASSIGNMENT IS LOAD-BEARING - do not remove it as "dead code" because nothing in the TS calls
// window.updateGlobalVariables directly. Webpack only exposes this function as a MODULE export; without
// the assignment the bare `window.updateGlobalVariables` that CsIndexedDbJsHelper.setValueByKey /
// deleteValueByKey probe for is undefined, their `typeof ... === 'function'` guard silently fails, and
// every C# SetValueByKeyAsync writes IndexedDB but never updates the matching __<key> window global.
// C# reads (BlazorClientCsIndexedDbJsHelper) only ever read window.__<key>, so the value then reads back
// as null for the rest of the page load - it only appears after a reload, via the hydration block below.
window.updateGlobalVariables = updateGlobalVariables;

(function (global) {

  if (typeof (global) === "undefined") {
    throw new Error("window is undefined");
  }

  // There used to be a "no back button" hack here: on load it appended "#" to the URL, then "!" 50ms later, and an
  // onhashchange handler forced the hash back. It is GONE and must not come back. In a background tab Chrome clamps
  // that 50ms timer to ~1s, so the hash change landed after Blazor's interactive router was listening; Blazor took it
  // for a Back/Forward navigation and answered with history.go(0) - a reload - and the reloaded page, still hidden, did
  // it again: an endless 1-per-second reload loop in any background tab (2026-10-12). To block leaving a page, use
  // Blazor's NavigationLock instead.
  global.onload = function () {
    // Disables backspace on page except on input fields and textarea..
    document.body.onkeydown = function (e: any) {
      const elm = e.target.nodeName.toLowerCase();
      if (e.which === 8 && (elm !== 'input' && elm !== 'textarea')) {
        e.preventDefault();
      }
      // Stopping the event bubbling up the DOM tree...
      e.stopPropagation();
    };
  }
})(window);

// Reads ONE stored key from IndexedDB and mirrors it into its window global. Throws if the read fails, so
// the caller can tell a failed read apart from a key that genuinely has no stored value.
async function hydrateGlobalKey(key: string): Promise<void> {
  if (HydratedGlobalKeyNames.indexOf(key) < 0) {
    throw new Error("hydrateGlobalKey: unsupported key " + key);
  }

  // Read IndexedDB directly: this THROWS on a failed read. getCsDeviceSignature / getCsContextKey catch their
  // own read errors and return null, which would be indistinguishable from "nothing stored".
  let value: any = await new CsIndexedDbJsHelper().getValueByKey(key);

  // Nothing stored - only these two helpers mint a new value, exactly as they always did at startup.
  if (!value && key === CsDeviceSignatureKeyName) {
    if (!window.__CsDeviceHelper) {
      throw new Error("window.__CsDeviceHelper == null");
    }
    value = await window.__CsDeviceHelper.getCsDeviceSignature();
  }
  else if (!value && key === CsContextKeyName) {
    if (!window.__CsContextKeyHelper) {
      throw new Error("window.__CsContextKeyHelper == null");
    }
    value = await window.__CsContextKeyHelper.getCsContextKey();
  }

  updateGlobalVariables(key, value);
  console.log(key + (value ? " loaded successfully" : " is null/undefined"));

  // The value is already in its global, so a logging failure must not mark the key as failed.
  if (value && (key === CsDeviceSignatureKeyName || key === CsContextKeyName)) {
    try {
      await csLogHelper.logAsync(
        LogMessageTypeEnum.Info,
        false,
        "NpmJS",
        "OnLoad",
        (key === CsDeviceSignatureKeyName ? "csDeviceSignature:" : "csContextKey:") + value,
        null
      );
    }
    catch (logErr) {
      console.error("Error logging global variable " + key + ":", logErr);
    }
  }
}

// The keys hydrated from IndexedDB at startup, in the order they were always read.
const HydratedGlobalKeyNames: string[] = [
  CsDeviceSignatureKeyName,
  CsContextKeyName,
  CsDeviceIdKeyName,
  CsUserSignInResponseIdKeyName,
  CsWksCsUserContextIdKeyName,
  CsRegionCodeKeyName
];

window.__CsGlobalsFailedKeys = [];
window.__CsHydrateGlobalKey = hydrateGlobalKey;

// Load the stored __Cs* values from IndexedDB on startup and store them on window.
// Assigned to __CsGlobalsReadyPromise so C# (GetValueByKeyAsync) can AWAIT this hydration before reading a
// __Cs* global — otherwise a fresh load (browser back) reads the null initialisers before hydration finishes.
//
// Each key is hydrated in its OWN try/catch. It used to be one try around all six, so a single failed read
// (the device signature is first) left every later key at its null initialiser while the promise still
// resolved - and C# then trusted those nulls as "nothing stored": a guest sign-in, a new CsDevice and a
// forced SelectRegion with IndexedDB intact. A failed key is recorded in __CsGlobalsFailedKeys instead, so
// the C# read reports it as not ready and retries.
window.__CsGlobalsReadyPromise = globalThis.__CsGlobalsReadyPromise = (async () => {
  console.log("Starting setting global variables...");

  for (const key of HydratedGlobalKeyNames) {
    try {
      await hydrateGlobalKey(key);
    }
    catch (err) {
      window.__CsGlobalsFailedKeys?.push(key);
      console.error("Error setting global variable " + key + ":", err);
      try {
        await csLogHelper.logAsync(
          LogMessageTypeEnum.Error,
          false,
          "NpmJS",
          "OnLoad",
          "setting global variable " + key + ":",
          err
        );
      }
      catch (logErr) {
        console.error("Error logging the failed global variable " + key + ":", logErr);
      }
    }
  }

  try {
    if (window.__CsJsHelper) {
      const browserWindowInfo = window.__CsJsHelper.getBrowserWindowInfo();
      updateGlobalVariables(BrowserWindowInfoKeyName, browserWindowInfo);

      const parsedUserAgent = window.__CsJsHelper.getParsedUserAgent();
      updateGlobalVariables(BowserParserParsedResultKeyName, parsedUserAgent);
    }
    else {
      console.log("window.__CsJsHelper == null")
    }
  }
  catch (err) {
    console.error("Error setting browser global variables:", err);
  }
})();

console.log("Hello aa.cs.client.blazor.aspnetcore.net version 1.2011.3438 World | 2026-07-22 21H50 !");
